import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Validators } from '@angular/forms';
import { VisaInventoryService } from 'src/app/business-service/visa-inventory/visa-inventory.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';

@Component({
  selector: 'app-visa-important-information-form',
  templateUrl: './visa-important-information-form.component.html',
  styleUrls: ['./visa-important-information-form.component.scss'],
})
export class VisaImportantInformationFormComponent  implements OnInit {

  countryVisaInformationForm!: FormGroup;
  editVisaInformationId:any;

  formResponse: any;

  // TODO: use LOV here

  visaTypes: any = [
    {
      name: 'Tourist Visa',
      key: 'Tourist Visa'
    },
    {
      name: 'Business Visa',
      key: 'Business Visa'
    },
    {
      name: 'Student Visa',
      key: 'Student Visa'
    },
    {
      name: 'Transit Visa',
      key: 'Transit Visa'
    },
    {
      name: 'Work Visa',
      key: 'Work Visa'
    },
    {
      name: 'Family Visa',
      key: 'Family Visa'
    },
    {
      name: 'PR Visa',
      key: 'PR Visa'
    }
  ]

  applicantTypes: any = [
    {
      name: 'Retired',
      key: 'Retired'
    },
    {
      name: 'Employee',
      key: 'Employee'
    },
    {
      name: 'Self Employed',
      key: 'Self Employed'
    },
    {
      name: 'Student',
      key: 'Student'
    }
  ]

  constructor(
    private _modalController: ModalController,
    private _fb : FormBuilder,
    private _visaInventoryService: VisaInventoryService,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService,
    private _validationService: InputValidationsService,
    private _reloadService: ComponentReloadService
  ) { }

  ngOnInit() {
    this.countryVisaInformationForm = this._fb.group({
      countryInfo: this._fb.group({
        country: ['', [Validators.required]],
        currency: ['', [Validators.required]],
        timeZone: ['', [Validators.required]],
        address: [''],
        phone: [''],
        email: ['', [Validators.required, Validators.email]],
        website: ['', [Validators.required, this._validationService.validateWebsiteUrl]]
      }),
      mandatoryDocuments: this._fb.group({
        data: this._fb.array([])
      }),
      documentsBasedOnVisa: this._fb.group({
        data: this._fb.array([])
      }),
      otherDocuments: this._fb.group({
        data: this._fb.array([])
      }),
      keyPoints: this._fb.group({
        data: this._fb.array([])
      }),
      restrictedItems: this._fb.group({
        data: this._fb.array([])
      }),
      importantNotes: this._fb.group({
        data: this._fb.array([])
      }),
      detailsAboutStay: this._fb.group({  
        data: this._fb.array([])
      }),
      status: [''],
      countryId: [null],
      id: [null],
      ownershipRole: [''],
      ownership: [''],
      createdBy: [''],
      createDate: [''],
      organizationId: [null]
    })

    if(this.editVisaInformationId){
      this._visaInventoryService.getVisaInformationForCountryById(this.editVisaInformationId).subscribe((data)=>{
        this.patchVisaInformationForm(data);
      })
    }
  }

  closeModal(){
    this._modalController.dismiss();
  }

  // Documetns form array

  mandatoryDocumentsArray(): FormArray{
    return this.countryVisaInformationForm.get('mandatoryDocuments.data') as FormArray;
  }

  documentsBasedOnVisaType():  FormArray{
    return this.countryVisaInformationForm.get('documentsBasedOnVisa.data') as FormArray;
  }

  otherDocumentsArray(): FormArray{
    return this.countryVisaInformationForm.get('otherDocuments.data') as FormArray;
  }

  keyPointsToNoteArray(): FormArray{
    return this.countryVisaInformationForm.get('keyPoints.data') as FormArray;
  }

  prohibitedOrRestrictedItemsArray(): FormArray{
    return this.countryVisaInformationForm.get('restrictedItems.data') as FormArray;
  }

  importantNotesArray(): FormArray{
    return this.countryVisaInformationForm.get('importantNotes.data') as FormArray;
  }

  detailsAboutStayArray(): FormArray{
    return this.countryVisaInformationForm.get('detailsAboutStay.data') as FormArray;
  }

  // Add and remove document funtions
  addMandatoryDocument(){
    this.mandatoryDocumentsArray().push(this.createDocumentItem());
  }

  removeMandatoryDocument(index: number){
    this.mandatoryDocumentsArray().removeAt(index);
  }

  addDocumentsBasedOnVisaType(){
    this.documentsBasedOnVisaType().push(this.createDocumentItemForVisaType());
  }

  removeDocumentsBasedOnVisaType(index: number){
    this.documentsBasedOnVisaType().removeAt(index);
  }

  addOtherDocument(){
    this.otherDocumentsArray().push(this.createDocumentItem());
  }

  removeOtherDocument(index: number){
    this.otherDocumentsArray().removeAt(index);
  }
  
  addKeyPointsToNote(){
    this.keyPointsToNoteArray().push(this.createDocumentItem());
  }

  removeKeyPointsToNote(index: number){
    this.keyPointsToNoteArray().removeAt(index);
  }

  addProhibitedOrRestrictedItems(){
    this.prohibitedOrRestrictedItemsArray().push(this.createDocumentItem());
  }

  removeProhibitedOrRestrictedItems(index: number){
    this.prohibitedOrRestrictedItemsArray().removeAt(index);
  }

  addImportantNotes(){
    this.importantNotesArray().push(this.createDocumentItem());
  }

  removeImportantNotes(index: number){
    this.importantNotesArray().removeAt(index);
  }

  addDetailsAboutStay(){
    this.detailsAboutStayArray().push(this.createDocumentItem());
  }

  removeDetailsAboutStay(index: number){
    this.detailsAboutStayArray().removeAt(index);
  }
  

  createDocumentItem(): FormGroup{
    let group = this._fb.group({
      name: ['', [Validators.required]],
      note: ['']
    })
    return group;
  }

  createDocumentItemForVisaType(): FormGroup{
    let group = this._fb.group({
      name: ['', [Validators.required]],
      note: [''],
      visaTypes: [[], [Validators.required, this._validationService.arrayNotEmptyValidator()]],
      applicantTypes: [[], [Validators.required, this._validationService.arrayNotEmptyValidator()]]
    })
    return group;
  }

  // Visa type selections
  toggleSelectAllVisaType(event: any, index: number){
    let selectAll = event?.target?.checked;
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    if(selectAll){
      visaType?.setValue(this.visaTypes.map((item : any) => item.key));
    }else{
      visaType?.setValue([]);
    }
    visaType?.markAsTouched();
  }

  checkAllVisaSelected(index:number){
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    return visaType?.value?.length === this.visaTypes?.length;
  }

  toggleVisaType(event:any, index:number, value:any){
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    let selectedVisas = visaType?.value;
    
    if(event?.target?.checked){
      selectedVisas.push(value);
      visaType?.setValue(selectedVisas)
    }else{
      let index = selectedVisas.indexOf(value);
      selectedVisas.splice(index, 1);
      visaType?.setValue(selectedVisas);
    }
    visaType?.markAsTouched();
  }

  checkVisaTypeSelected(index: number, value:any){
    let visaType = this.documentsBasedOnVisaType().at(index).get('visaTypes');
    return visaType?.value.includes(value);
  }

  // Applicant type selection
  toggleSelectAllApplicantType(event: any, index: number){
    let selectAll = event?.target?.checked;
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    if(selectAll){
      applicantType?.setValue(this.applicantTypes.map((item : any) => item.key));
    } else{
      applicantType?.setValue([]);
    }
    applicantType?.markAsTouched();
  }

  checkAllApplicantTypeSelected(index:number){
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    return applicantType?.value?.length === this.applicantTypes?.length;
  }

  toggleApplicantType(event:any, index:number, value:any){
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    let selectedApplicantTypes = applicantType?.value;
    
    if(event?.target?.checked){
      selectedApplicantTypes.push(value);
      applicantType?.setValue(selectedApplicantTypes)
    } else{
      let index = selectedApplicantTypes.indexOf(value);
      selectedApplicantTypes.splice(index, 1);
      applicantType?.setValue(selectedApplicantTypes);
    }
    applicantType?.markAsTouched();
  }

  checkApplicantTypeSelected(index: number, value:any){
    let applicantType = this.documentsBasedOnVisaType().at(index).get('applicantTypes');
    return applicantType?.value.includes(value);
  }

  // Patching data if edit

  patchVisaInformationForm(formData:any){
    this.countryVisaInformationForm.patchValue(formData);

    if(formData.mandatoryDocuments?.data?.length > 0){
      this.mandatoryDocumentsArray().clear();
      formData.mandatoryDocuments.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.mandatoryDocumentsArray().push(group);
      });
    }
    
    if(formData.documentsBasedOnVisa?.data?.length > 0){
      this.documentsBasedOnVisaType().clear();
      formData.documentsBasedOnVisa.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItemForVisaType();
        group.patchValue(item);
        this.documentsBasedOnVisaType().push(group);
      });
    }

    if(formData.otherDocuments?.data?.length > 0){
      this.otherDocumentsArray().clear();
      formData.otherDocuments.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.otherDocumentsArray().push(group);
      });
    }

    if(formData.keyPoints?.data?.length > 0){
      this.keyPointsToNoteArray().clear();
      formData.keyPoints.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.keyPointsToNoteArray().push(group);
      });
    }

    if(formData.restrictedItems?.data?.length > 0){
      this.prohibitedOrRestrictedItemsArray().clear();
      formData.restrictedItems.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.prohibitedOrRestrictedItemsArray().push(group);
      });
    }

    if(formData.importantNotes?.data?.length > 0){
      this.importantNotesArray().clear();
      formData.importantNotes.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.importantNotesArray().push(group);
      });
    }

    if(formData.detailsAboutStay?.data?.length > 0){
      this.detailsAboutStayArray().clear();
      formData.detailsAboutStay.data.forEach((item:any, index:number) => {
        let group = this.createDocumentItem();
        group.patchValue(item);
        this.detailsAboutStayArray().push(group);
      });
    }
  }

  // Funtion to check invalid control in array
  checkInvalidControlInArray(array:FormArray, index: number, control: string): boolean | undefined{
    return array.at(index).get(control)?.invalid && array.at(index).get(control)?.touched
  }

  // Form Submission funtions


  async onSubmit(): Promise<boolean> {
    if (this.countryVisaInformationForm.valid) {
      let formData = this.serializeFormData(this.countryVisaInformationForm.value);
  
      try {
        const res = await this._visaInventoryService.addVisaInformationForCountry(formData).toPromise();
        this.formResponse = res;
        this._reloadService.triggerVisaInventoryReload();
        this.closeModal();
        if(this.editVisaInformationId){
          this._responseNotificationService.showMessage("Important Information For Country Updated Successfully.");
        }else{
          this._responseNotificationService.showMessage("Important Information For Country Added Successfully.");
        }
        return true;
      } catch (error) {
        console.error("Error while adding/updating Country Info", error);
        this._responseNotificationService.showMessage("Failed to add/update country info.", true);
        return false;
      }
    } else {
      this._responseNotificationService.showMessage("Form is invalid, please check", true);
      this.countryVisaInformationForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      return false;
    }
  }

  serializeFormData(formData: any) {        
    let serializedData = {
      ...formData, 
      countryInfo: {
        ...formData.countryInfo,
        country: formData.countryInfo.country.name
      }
    }
    return serializedData;
  }

  async saveVisaInformation(){
    if(await this.onSubmit()){
      if(this.formResponse){
        this._modalPopupService.openVisaCountryInventoryReview(this.formResponse.countryId);
      }
    }
  }

  async saveAndNextVisaInformation(){
    if(await this.onSubmit()){
      this.closeModal();
      this._modalPopupService.openInventoryVisaInformationForm();
    }
  }

  countrySelected(country:any){
    this._visaInventoryService.checkForExistingCountry(country.name).subscribe({
      next: async (res:any) => {
        if(res.countryId){
          if(await this._globalService.confirmActionPopup(`Visa checklist for ${country.name}(${res.countryId}), do wish to edit existing record for ${country.name}`)){
            await this._modalPopupService.closeAllModals();
            await this._modalPopupService.openInventoryVisaInformationForm(res.countryId);
          }else{
            this.closeModal();
          }
          
        }else{
          return;
        }
      },
      error: (error:any) => {
        console.error("Error while checking for existing country", error);
        this._responseNotificationService.showMessage("Failed to check for existing country info.", true);
      }
    })
  }
  
}
